import { render, staticRenderFns } from "./HealthCovid19.vue?vue&type=template&id=f51d39e6&scoped=true"
import script from "./HealthCovid19.vue?vue&type=script&lang=js"
export * from "./HealthCovid19.vue?vue&type=script&lang=js"
import style0 from "./HealthCovid19.vue?vue&type=style&index=0&id=f51d39e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51d39e6",
  null
  
)

/* custom blocks */
import block0 from "./HealthCovid19.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports